const colors = ['#b9fbc0', '#98f4e1', '#90dbf4', '#a3c4f3', '#ffcfd2', '#f1c0d8', '#fde4cf',]
const nightColors = ['#45ad4e', '#3b649b', '#77338c', '#77463e', '#2d7eef', '#b55359', '#ed8631']

export function getOriColor(officerOriId, nightMode = false, userPreferences) {
  // Use the modulus operator to ensure the index is within the range of the colors array
  if(userPreferences?.oriColor !== 'true') return 'inherit';
  const index = officerOriId % colors.length;
  return nightMode ? nightColors[index] : colors[index];
}